import { render, staticRenderFns } from "./Collapsor.vue?vue&type=template&id=60378d06"
import script from "./Collapsor.vue?vue&type=script&lang=js"
export * from "./Collapsor.vue?vue&type=script&lang=js"
import style0 from "./Collapsor.vue?vue&type=style&index=0&id=60378d06&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports